"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stores = function (_Component) {
  (0, _inherits3.default)(Stores, _Component);

  function Stores() {
    (0, _classCallCheck3.default)(this, Stores);
    return (0, _possibleConstructorReturn3.default)(this, (Stores.__proto__ || (0, _getPrototypeOf2.default)(Stores)).apply(this, arguments));
  }

  (0, _createClass3.default)(Stores, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "stores-container" },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-3" },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                to: "https://play.google.com/store/apps/details?id=fi.maaporssi.app",
                target: "_blank"
              },
              _react2.default.createElement("img", { src: "/img/google-play-badge.png" })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-3" },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                to: "https://apps.apple.com/us/app/maaapp/id1191743095?ls=1",
                target: "_blank"
              },
              _react2.default.createElement("img", { src: "/img/apple-store-badge.png" })
            )
          ),
          _react2.default.createElement("div", { className: "col col-sm-3" })
        )
      );
    }
  }]);
  return Stores;
}(_react.Component);

exports.default = Stores;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/stores/Stores.js
 ** module id = 1186
 ** module chunks = 0
 **/